import request from '@/utils/request';

// 获取大师列表
export function getMastersList(params) {
  return request({
    url: '/gateway/masters/list',
    method: 'get',
    params
  });
}

// 获取大师详情
export function getMasterDetail(id) {
  return request({
    url: `/gateway/masters/${id}`,
    method: 'get'
  });
}